function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
import { isEmptyBodyStatusCode } from "./helpers";
var _response = new WeakMap(), _result = new WeakMap(), _extractData = new WeakSet(), _tryToParseJson = new WeakSet(), _tryToParseBlob = new WeakSet(), _tryToParseFormData = new WeakSet(), _tryToWrapper = new WeakSet();
export class FetcherResponseBuilder {
    build() {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_class_private_field_get(_this, _response) || isEmptyBodyStatusCode(_class_private_field_get(_this, _response).status)) {
                return _class_private_field_get(_this, _result);
            }
            yield _class_private_method_get(_this, _extractData, extractData).call(_this);
            return _class_private_field_get(_this, _result);
        })();
    }
    populateResponse(response) {
        _class_private_field_set(this, _response, response.clone());
        _class_private_field_get(this, _result).ok = response.ok;
        _class_private_field_get(this, _result).status = response.status;
        _class_private_field_get(this, _result).statusText = response.statusText;
        _class_private_field_get(this, _result).headers = response.headers;
        _class_private_field_get(this, _result).url = response.url;
        return this;
    }
    constructor(request, response){
        _class_private_method_init(this, _extractData);
        _class_private_method_init(this, _tryToParseJson);
        _class_private_method_init(this, _tryToParseBlob);
        _class_private_method_init(this, _tryToParseFormData);
        _class_private_method_init(this, _tryToWrapper);
        _class_private_field_init(this, _response, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _result, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _result, {
            ok: false,
            status: 0,
            statusText: '',
            headers: {},
            url: '',
            request: request || {
                url: ''
            }
        });
        if (response) {
            this.populateResponse(response);
        }
    }
} /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/  /*#__PURE__*/ 
function extractData() {
    return _extractData1.apply(this, arguments);
}
function _extractData1() {
    _extractData1 = _async_to_generator(function*() {
        if (!_class_private_field_get(this, _response)) return;
        if (isEmptyBodyStatusCode(_class_private_field_get(this, _response).status)) return;
        const parsers = [
            _class_private_method_get(this, _tryToParseJson, tryToParseJson).bind(this),
            _class_private_method_get(this, _tryToParseFormData, tryToParseFormData).bind(this),
            // TODO: check if it's possible to parse formData
            ..._class_private_field_get(this, _response).ok ? [
                _class_private_method_get(this, _tryToParseBlob, tryToParseBlob).bind(this)
            ] : []
        ];
        for (const parser of parsers){
            const isParsed = yield parser();
            if (isParsed) break;
        }
    });
    return _extractData1.apply(this, arguments);
}
function tryToParseJson() {
    return _tryToParseJson1.apply(this, arguments);
}
function _tryToParseJson1() {
    _tryToParseJson1 = _async_to_generator(function*() {
        var _class_private_field_get_clone, _class_private_field_get1;
        // Clone response to be able to read response body multiple times
        // https://developer.mozilla.org/en-US/docs/Web/API/Response/bodyUsed
        return _class_private_method_get(this, _tryToWrapper, tryToWrapper).call(this, (_class_private_field_get1 = _class_private_field_get(this, _response)) === null || _class_private_field_get1 === void 0 ? void 0 : (_class_private_field_get_clone = _class_private_field_get1.clone()) === null || _class_private_field_get_clone === void 0 ? void 0 : _class_private_field_get_clone.json());
    });
    return _tryToParseJson1.apply(this, arguments);
}
function tryToParseBlob() {
    return _tryToParseBlob1.apply(this, arguments);
}
function _tryToParseBlob1() {
    _tryToParseBlob1 = _async_to_generator(function*() {
        var _class_private_field_get_clone, _class_private_field_get1;
        return _class_private_method_get(this, _tryToWrapper, tryToWrapper).call(this, (_class_private_field_get1 = _class_private_field_get(this, _response)) === null || _class_private_field_get1 === void 0 ? void 0 : (_class_private_field_get_clone = _class_private_field_get1.clone()) === null || _class_private_field_get_clone === void 0 ? void 0 : _class_private_field_get_clone.blob());
    });
    return _tryToParseBlob1.apply(this, arguments);
}
function tryToParseFormData() {
    return _tryToParseFormData1.apply(this, arguments);
}
function _tryToParseFormData1() {
    _tryToParseFormData1 = _async_to_generator(function*() {
        var _class_private_field_get_clone, _class_private_field_get1;
        return _class_private_method_get(this, _tryToWrapper, tryToWrapper).call(this, (_class_private_field_get1 = _class_private_field_get(this, _response)) === null || _class_private_field_get1 === void 0 ? void 0 : (_class_private_field_get_clone = _class_private_field_get1.clone()) === null || _class_private_field_get_clone === void 0 ? void 0 : _class_private_field_get_clone.formData());
    });
    return _tryToParseFormData1.apply(this, arguments);
}
function tryToWrapper(promise) {
    return _tryToWrapper1.apply(this, arguments);
}
function _tryToWrapper1() {
    _tryToWrapper1 = _async_to_generator(function*(promise) {
        try {
            _class_private_field_get(this, _result).data = yield promise;
            return true;
        } catch (e) {
            return false;
        }
    });
    return _tryToWrapper1.apply(this, arguments);
}

//# sourceMappingURL=data:application/json;base64,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